export enum MaatAuditPlanStatus {
  AuditStarted = 'auditstarted',
  DocumentsRequested = 'documentsrequested',
  DocumentsOverdue = 'documentsoverdue',
  DocumentsSupplied = 'documentssupplied',
  AwaitingInspection = 'awaitinginspection',
  NcqInProgress = 'ncqinprogress',
  ReferredToSeniorProjectOfficer = 'referredtoseniorprojectofficer',
  ReferredToManager = 'referredtomanager',
  Completed = 'completed',
  Finalised = 'finalised'
}

export const MaatAuditPlanStatusDescriptions: Record<MaatAuditPlanStatus, string> = {
  [MaatAuditPlanStatus.AuditStarted]: 'Audit started',
  [MaatAuditPlanStatus.DocumentsRequested]: 'Documents requested',
  [MaatAuditPlanStatus.DocumentsOverdue]: 'Documents overdue',
  [MaatAuditPlanStatus.DocumentsSupplied]: 'Documents supplied',
  [MaatAuditPlanStatus.AwaitingInspection]: 'Awaiting inspection',
  [MaatAuditPlanStatus.NcqInProgress]: 'NCQ in progress',
  [MaatAuditPlanStatus.ReferredToSeniorProjectOfficer]: 'Referred to SPO',
  [MaatAuditPlanStatus.ReferredToManager]: 'Referred to Manager',
  [MaatAuditPlanStatus.Completed]: 'Completed',
  [MaatAuditPlanStatus.Finalised]: 'Finalised',
};
